<mat-drawer-container hasBackdrop="true" class="information-drawer-container">
  <mat-drawer #informationDrawer mode="over" class="information-drawer">
    <mat-card appearance="outlined">
      <button mat-icon-button class="close-button" (click)="closeDrawer()">
        <mat-icon>clear</mat-icon>
      </button>
      @if (!loading && iframeSafeUrl) {
        <iframe title="information-iframe" class="information-iframe" [src]="iframeSafeUrl" frameborder="0"></iframe>
      }
      @if (loading) {
        <mat-spinner class="loading-spinner"></mat-spinner>
      }
    </mat-card>
  </mat-drawer>
  <mat-drawer-content></mat-drawer-content>
</mat-drawer-container>
